import React from 'react';
import { Element } from 'react-scroll';

import styles from 'sections/about/about.module.css';
import { useTranslation } from 'react-i18next';
import { QuestionsLazy } from 'components/questions/QuestionsLazy';
import { QuestionsList } from 'components/questions/QuestionsList';
import { AnimatedPart } from 'components/animatedPart/AnimatedPart';
import {
    getDesktopSrc2x,
    getDesktopSrc3x,
    getDesktopSrcWebp,
    getDesktopSrcWebp2x,
    getDesktopSrcWebp3x,
} from 'utils/imageResize.utils';

const About = () => {
    const { t } = useTranslation();
    const src =
        'https://velvety-general.s3.eu-north-1.amazonaws.com/mobilePhone/mobilePhone%401x.png';

    const desktopSrc2x = getDesktopSrc2x(src);
    const desktopSrc3x = getDesktopSrc3x(src);

    const desktopSrcWebp = getDesktopSrcWebp(src);
    const desktopSrcWebp2x = getDesktopSrcWebp2x(desktopSrcWebp);
    const desktopSrcWebp3x = getDesktopSrcWebp3x(desktopSrcWebp);

    return (
        <section id="section-about" className={styles.section__about}>
            <Element name="about" className={styles.about}>
                <div className={styles.about__desktop}>
                    <div className={styles.mobilePhone}>
                        <div className={styles.mobilePhone__pic}>
                            <picture>
                                <source
                                    type="image/webp"
                                    srcSet={`${desktopSrcWebp} 1x, ${desktopSrcWebp2x} 2x, ${desktopSrcWebp3x} 3x`}
                                    sizes="100vw"
                                />

                                <img
                                    src={src}
                                    srcSet={`${desktopSrc2x} 2x, ${desktopSrc3x} 3x`}
                                    sizes="100vw"
                                    alt="mobile phone"
                                    width="100%"
                                    height="100%"
                                />
                            </picture>
                        </div>
                        <div className={styles.mobilePhone__messages}>
                            <QuestionsList />
                        </div>
                    </div>
                </div>
                <div className={styles.about__mobile}>
                    <QuestionsLazy />
                </div>

                <div className={styles.text}>
                    <AnimatedPart>{t('about.teamUpWithUsText')}</AnimatedPart>
                </div>
            </Element>
        </section>
    );
};
export default About;
